module.exports = __webpack_public_path__ + "media/images/pic/saska/hero_saska_adults-1e954769151d4b8df067337f4fee58f9.svg";